<template>
  <div>
     <h2>Заказ:   {{purchases.id}} <span v-if="purchases.ID_1C">  / {{purchases.ID_1C}}</span></h2>
 
     <div>
      <b>Дата:</b>
      {{purchases.created_at | dateTime}}

    </div>
     <div>
      <b>Статус:</b>
      {{purchases.status}}

    </div>

    <div>
             <v-btn
                  v-if="$store.state.role[2]"
                    color="primary"
                    @click="exportToServer(purchases,'brandstore')"
                  >
                    BrandStore
                    <v-icon>mdi-database-import</v-icon>
                  </v-btn>
             <v-btn
                  v-if="$store.state.role[2]"
                    color="primary"
                    @click="exportToServer(purchases,'electron')"
                  >
                    Electron
                    <v-icon>mdi-database-import</v-icon>
                  </v-btn>
           
                  <v-btn  v-if="$store.state.role[2]" color="primary" @click="exportToServer(purchases,'olam')">
                    Olam
                    <v-icon>mdi-database-import</v-icon>
                  </v-btn>
             
                  <v-btn v-if="$store.state.role[2]"
             
                    color="primary"
                    @click="exportToServer(purchases,'mobilezone')"
                  >
                    MobileZone
                    <v-icon>mdi-database-import</v-icon>
                  </v-btn>
            
              <v-btn
                  
                  v-if="$store.state.role[4]"
                  color="warning"
                  @click="serverSend(purchases.id)"
                  text
                >Отправить в 1с</v-btn>
    </div>
  
     <div>
      <b>Вид заказа:</b>
      <span v-if="purchases.type==2"> Бронь</span>
      <span v-else> Заказ</span>

    </div>


     <div>
      <b>Запрос на скидку:</b>
      <span v-if="purchases.is_discount_query"> ДА</span>
      <span v-else> НЕТ</span>

    </div>

     <div>
      <b>Итоговая цена:</b>
         {{purchases.price_total}} сум

    </div>

     <div>
      <b>Комментарий:</b>
      {{purchases.comment}}

    </div>

    <h4>Данные заказчика</h4>
    
    <div>
      <b>Заказчик:</b>
      {{purchases.distributor.name}}

    </div>

    <div>
      <b>Телефон:</b>
      {{purchases.distributor.phone}}
    </div>
    <div>
      <b>Компания:</b>
      {{purchases.distributor.name_company}}
    </div>
    
    <div>
      <b>Адрес:</b>
      {{purchases.distributor.address}}
    </div>
   
    <div>
      <b>Лимит кредитной линии:</b>
      {{purchases.distributor.deposit_limit}}
    </div>
    <div>
      <b>Долг:</b>
      {{purchases.distributor.debt}}
    </div>
        <br />



    <hr />

    <h4>Заказы</h4>
    <v-data-table class="mt-5" :headers="headers" :items="purchases.purchases" hide-actions>
      <template slot="headerCell" slot-scope="{ header }">
        <span
          class="subheading font-weight-light text-success text--darken-3"
          v-text="header.text"
        />
      </template>

      <template slot="items" slot-scope="{ item }">
        <td class="text-xs-left">
          <img
            height="80"
            v-if="item.product_images.length"
            :src="item.product_images[0].image_medium"
            alt
          />
        </td>
        <td class="text-xs-left">{{item.id}}</td>
        <td class="text-xs-left">{{item.title}}</td>
        <td class="text-xs-left">
          <v-text-field
            :disabled="!$store.state.role[7]"
            type="number"
            v-model="item.pivot.price"
            label="сум"
          ></v-text-field>
        </td>
        <td class="text-xs-left">
          <v-text-field
            :disabled="!$store.state.role[7]"
            v-model="item.pivot.cart_count"
            label="штук"
            type="number"
          ></v-text-field>
        </td>
        <td class="text-xs-left" style="min-width:200px">
          {{item.pivot.cart_count*item.pivot.price | numberWithSpaces}} сум
          <v-icon
            v-if="$store.state.role[7]"
            class="ml-3 text-success"
            @click="changeItem(item)"
          >mdi-content-save-outline</v-icon>
        </td>
        <td class="text-xs-right">
          <v-icon
            v-if="$store.state.role[7]"
            class="mr-2 text-danger"
            @click="removeItem(item)"
          >mdi-close</v-icon>
        </td>
      </template>
    </v-data-table>
    <br />
  </div>
</template>

<script>
export default {
  data: () => ({
    headers: [
      {
        sortable: false,
        text: "",
        value: "id"
      },
      {
        sortable: false,
        text: "ID",
        value: "id"
      },
      {
        sortable: false,
        text: "Наименование",
        value: "id"
      },
      {
        sortable: false,
        text: "Цена за ед.",
        value: "id"
      },
      {
        sortable: false,
        text: "Количество",
        value: "id",
        align: "left"
      },
      {
        sortable: false,
        text: "Итог",
        value: "id",
        align: "left"
      },
      {
        sortable: false,
        text: "",
        value: "id",
        align: "right"
      }
    ]
  }),
  props: ["purchases", "getItems", "exportToServer","serverSend"],
  methods: {
    removeItem(item) {
      if (item) {
        this.$dialog
          .confirm("Вы точно хотите удалить?", {
            okText: "Удалить",
            cancelText: "Отмена"
          })
          .then(() => {
            axios
              .delete("admin/distributors/orders/purchase/remove", {
                data: {
                  product_id: item.pivot.product_id,
                  order_id: item.pivot.order_id
                }
              })
              .then(response => {
                this.$toast.success({
                  title: "Удаление",
                  message: "Товар удален с заказа"
                });

                this.purchasesItem = response.data.purchases;
              })
              .catch(error => {
                this.$toast.error({
                  title: "Удаление",
                  message: "Ошибка удаления"
                });
              })
              .finally(() => {});
          })
          .catch(() => {});
      }
    },
    changeItem(item) {
      if (item) {
        this.$dialog
          .confirm("Вы точно хотите измкнить?", {
            okText: "Да, изменить",
            cancelText: "Отмена"
          })
          .then(() => {
            axios
              .put("admin/distributors/orders/purchase/change", {
                product_id: item.pivot.product_id,
                order_id: item.pivot.order_id,
                price: item.pivot.price,
                cart_count: item.pivot.cart_count
              })
              .then(response => {
                this.$toast.success({
                  title: "Удаление",
                  message: "Данные товара изменены успешно"
                });
                this.purchasesItem = response.data.purchases;
              })
              .catch(error => {
                this.$toast.error({
                  title: "Изменение",
                  message: "Ошибка изменения"
                });
              })
              .finally(() => {});
          })
          .catch(() => {});
      }
    }
  },
  computed: {
    purchasesItem: {
      get() {
        return this.purchases;
      },
      set(val) {
        this.purchases = val;
      }
    }
  }
};
</script>

